import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import './Footer.css';

const Footer = () => (
  <footer className="footer" id="contact">
    <div className="footer-inner">

      {/* ================= TOP ================= */}
      <div className="footer-top">

        {/* Brand */}
        <div className="footer-brand">
          <img
            src="/welogo.png"
            alt="WeIntern"
            className="footer-logo"
          />

          <p>
            Where Students Don't Wait for
            <br />
            Opportunity. They Build It.
          </p>

          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/company/weinternx/"
              target="_blank"
              rel="noreferrer"
              className="social-btn"
              aria-label="LinkedIn"
            >
              <Icon icon="mdi:linkedin" width={18} height={18} />
            </a>

            <a
              href="https://www.instagram.com/weintern.in"
              target="_blank"
              rel="noreferrer"
              className="social-btn"
              aria-label="Instagram"
            >
              <Icon icon="mdi:instagram" width={18} height={18} />
            </a>

            <a
              href="https://wa.me/917414974582"
              target="_blank"
              rel="noreferrer"
              className="social-btn"
              aria-label="WhatsApp"
            >
              <Icon icon="mdi:whatsapp" width={18} height={18} />
            </a>

            <a
              href="https://www.youtube.com/@weintern"
              target="_blank"
              rel="noreferrer"
              className="social-btn"
              aria-label="YouTube"
            >
              <Icon icon="mdi:youtube" width={18} height={18} />
            </a>
          </div>
        </div>

        {/* Company */}
        <div className="footer-col">
          <h5>Company</h5>

          <Link to="/about">
            Our Story
            <span>›</span>
          </Link>

          <a href="#ecosystem">
            How It Works
            <span>›</span>
          </a>

          <a href="#courses">
            Courses
            <span>›</span>
          </a>

          <a href="#testimonials">
            Intern Stories
            <span>›</span>
          </a>
        </div>

        {/* Join Us */}
        <div className="footer-col">
          <h5>Join Us</h5>

          <Link to="/internship">
            Apply as Intern
            <span>›</span>
          </Link>

          <a
            href="https://www.wenexa.in/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.preventDefault();
              window.open('https://www.wenexa.in/', '_blank', 'noopener,noreferrer');
            }}
          >
            Hire a Team
            <span>›</span>
          </a>

          <a
            href="https://www.wenexa.in/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.preventDefault();
              window.open('https://www.wenexa.in/', '_blank', 'noopener,noreferrer');
            }}
          >
            Partner With Us
            <span>›</span>
          </a>
        </div>

        {/* Contact */}
        <div className="footer-col footer-contact">
          <h5>Contact</h5>

          <a href="mailto:contact@we-intern.in">
            <Icon icon="mdi:email-outline" width={15} height={15} />
            contact@we-intern.in
          </a>

          <a href="tel:+917414974582">
            <Icon icon="mdi:phone" width={15} height={15} />
            +91 74149 74582
          </a>

          <span>
            <Icon icon="mdi:map-marker" width={15} height={15} />
            India · Remote-First
          </span>
        </div>

        {/* Location / Map */}
        <div className="footer-location">
          <h5>Our Location</h5>

          <div className="footer-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.289256198922!2d73.94289637506326!3d18.560993582540547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c36dbb5048ff%3A0xf69deab017762391!2sWEINTERN%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sus!4v1786969585545!5m2!1sen!2sus"
              title="WeIntern Private Limited Location"
              loading="lazy"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </div>
        </div>

      </div>

      {/* ================= BOTTOM ================= */}
      <div className="footer-bottom">

        <p>
          © 2024 WeIntern. All rights reserved.
          Built with <span className="heart">♥</span> by the WeIntern Team.
        </p>

        <div className="footer-legal">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span>|</span>
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>

      </div>

    </div>
  </footer>
);

export default Footer;